import {
  UnstakeAssetAcceptViewQuery,
  UnstakeAssetAcceptViewQueryNode,
} from '@bts-web/data-layer/server';
import { gqlNetworkFetch } from '@bts-web/utils-relay';

export const getUnstakeAssetAcceptData = async ({
  assetId,
}: {
  assetId: string;
}) => {
  const response = await gqlNetworkFetch<UnstakeAssetAcceptViewQuery>(
    UnstakeAssetAcceptViewQueryNode.params,
    { assetId },
  );

  return response;
};
